import { useTranslation } from 'react-i18next';
import { useCostTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setCostFilterHideEmpty,
  setCostFilterSearchTerm,
  setCostFilterSortBy,
  setCostFilterSortDirection,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { FilterListControls } from '../../components/filters-list/filters-list-controls';
import { getFilterOptions, getSortOptions } from '../../initiative-performance.helpers';
import { EpicSortOption } from '../../initiative-performance.type';
import { CostMode } from '../cost-tab.type';

export const FiltersSearch = () => {
  const i18n = useTranslation();
  const mode = useCostTabStore((state) => state.mode);
  const searchTerm = useCostTabStore((state) => state.filterControls.searchTerm);
  const sortBy = useCostTabStore((state) => state.filterControls.sortBy);
  const sortDirection = useCostTabStore((state) => state.filterControls.sortDirection);
  const hideEmpty = useCostTabStore((state) => state.filterControls.hideEmpty);

  if (mode === CostMode.ContributingTeams) {
    return null;
  }

  return (
    <FilterListControls
      searchTerm={searchTerm}
      onSearchChange={(value) => setCostFilterSearchTerm(value)}
      searchPlaceholder={i18n.t('strategy.filters.search_by_epic')}
      sortOptions={getSortOptions(i18n.t)}
      selectedSort={sortBy}
      onSortChange={(sortOption: string) => setCostFilterSortBy(sortOption as EpicSortOption)}
      sortDirection={sortDirection}
      onSortDirectionChange={(direction) => setCostFilterSortDirection(direction)}
      filterOptions={getFilterOptions(i18n.t)}
      selectedFilters={{ hideEmpty }}
      onFilterChange={(filterOption: string, value: boolean) => {
        if (filterOption === 'hideEmpty') {
          setCostFilterHideEmpty(value);
        }
      }}
    />
  );
};
